import {useAuth} from 'react-oidc-context';
import {useDispatch} from 'react-redux';
import {clearAuth} from '../store/slices/authSlice';
import {COGNITO_CLIENT_ID, COGNITO_DOMAIN, buildCognitoLogoutUrl} from '../config/cognito';

export const useLogout = () => {
    const auth = useAuth();
    const dispatch = useDispatch();

    return async () => {
        // 1. Revoke refresh token so it can't be used to get new access tokens
        const refreshToken = auth.user?.refresh_token;
        if (refreshToken) {
            try {
                await fetch(`${COGNITO_DOMAIN}/oauth2/revoke`, {
                    method: 'POST',
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                    body: new URLSearchParams({
                        token: refreshToken,
                        client_id: COGNITO_CLIENT_ID,
                    }),
                });
            } catch (error) {
                console.error('Failed to revoke refresh token:', error);
            }
        }

        // 2. Clear all local state
        dispatch(clearAuth());
        try {
            await auth.removeUser();
        } catch (error) {
            console.error('Error removing OIDC user:', error);
        }
        localStorage.clear();
        sessionStorage.clear();
        // Set flag AFTER clearing storage — survives the page reload because
        // sessionStorage persists within the same browser tab navigation.
        // This is a safety net: if LogoutCallbackPage never runs (e.g. Cognito
        // rejects the logout_uri), LoginPage still won't auto-trigger signinRedirect.
        sessionStorage.setItem('justLoggedOut', 'true');

        // 3. Redirect to Cognito logout to invalidate the SSO session cookie.
        //    Cognito redirects back to the app origin when done.
        window.location.href = buildCognitoLogoutUrl();
    };
};
